import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Fetch calendar events (public holidays + RDOs) once and expose a date classifier.
export function useCalendarEvents() {
  const [byDate, setByDate] = useState({});
  useEffect(() => {
    api.get("/calendar-events").then((r) => {
      const map = {};
      (r.data || []).forEach((e) => {
        map[e.date] = map[e.date] || { holiday: null, rdo: null };
        if (e.type === "public_holiday") map[e.date].holiday = e.name || "Public Holiday";
        if (e.type === "rdo") map[e.date].rdo = e.name || "Construction Industry RDO";
      });
      setByDate(map);
    }).catch(() => {});
  }, []);
  return byDate;
}

// Returns { holiday, rdo, both, dot } for a given YYYY-MM-DD.
export function classifyDate(byDate, dateStr) {
  const e = byDate[dateStr];
  if (!e) return { holiday: null, rdo: null, both: false, dot: null };
  const both = !!e.holiday && !!e.rdo;
  const dot = both ? "bg-red-500" : e.holiday ? "bg-yellow-400" : e.rdo ? "bg-orange-500" : null;
  return { holiday: e.holiday, rdo: e.rdo, both, dot };
}
